import React, { useState, useEffect } from "react";
import API from "../Services/axios";
import * as XLSX from 'xlsx';

const CFA = ({role}) => {
  const [cfas, setCFAs] = useState([]);
  const [envisionCfas, setEnvisionCfas] = useState([]);
  
  useEffect(() => {
    async function getCFAs() {
      const data = (await API.get("/cfa/admin/users")).data;
      var finData = [];
      var envision = [];
      for (let i = 0; i < data.length; i++) {
        // Use sk to reliably distinguish: envision entries have sk starting with cfa#envision#
        if (data[i].sk && data[i].sk.startsWith("cfa#envision#")) {
          envision.push(data[i]);
        } else {
          finData.push(data[i]);
        }
      }
      setCFAs(finData);
      setEnvisionCfas(envision);
    }
    getCFAs();
  }, []); // Run once on mount only

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  // Download CFA data as Excel
  const downloadCFAData = () => {
    if (cfas.length === 0) {
      alert('No CFA data to download.');
      return;
    }

    try {
      // Prepare data for Excel
      const excelData = cfas
        .sort((a, b) => parseInt(b.timestamp) - parseInt(a.timestamp))
        .map(data => ({
          'Timestamp': data.timestamp && !isNaN(parseInt(data.timestamp))
            ? formatDate(parseInt(data.timestamp))
            : "NA",
          'Name': data.name || "NA",
          'Registration Number': data.regNumber || "NA",
          'Phone Number': data.phoneNumber || "NA",
          'Whatsapp Number': data.whatsappNumber || "NA",
          'Email': data.email || "NA",
          'Srm Mail ID': data.srmEmail || "NA",
          'Year': data.year || "NA",
          'Branch': data.branch || "NA",
          'Preference 1': data.preference1 || "NA",
          'Preference 2': data.preference2 || "NA"
        }));

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Set column widths for better readability
      const columnWidths = [
        { wch: 20 }, // Timestamp
        { wch: 20 }, // Name
        { wch: 20 }, // Registration Number
        { wch: 15 }, // Phone Number
        { wch: 15 }, // Whatsapp Number
        { wch: 30 }, // Email
        { wch: 30 }, // Srm Mail ID
        { wch: 8 },  // Year
        { wch: 15 }, // Branch
        { wch: 20 }, // Preference 1
        { wch: 20 }  // Preference 2
      ];
      worksheet['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'CFA Data');

      // Write and download the file
      XLSX.writeFile(workbook, 'CFA_Data.xlsx');
    } catch (error) {
      console.error('Error downloading CFA data:', error);
      alert('Error downloading CFA data. Please try again.');
    }
  };

  // Download Envision CFA data as Excel
  const downloadEnvisionData = () => {
    if (envisionCfas.length === 0) {
      alert('No Envision CFA data to download.');
      return;
    }

    try {
      // Prepare data for Excel
      const excelData = envisionCfas
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        .map(data => ({
          'Timestamp': data.timestamp && !isNaN(new Date(data.timestamp).getTime())
            ? formatDate(data.timestamp)
            : "NA",
          'Name': data.name || "NA",
          'Registration Number': data.regNumber || "NA",
          'Phone Number': data.phoneNumber || "NA",
          'Whatsapp Number': data.whatsappNumber || "NA",
          'Email': data.email || "NA",
          'Srm Mail ID': data.srmEmail || "NA",
          'Year': data.year || "NA",
          'Branch': data.branch || "NA",
          'Preference 1': data.preference1 || "NA",
          'Preference 2': data.preference2 || "NA",
          'Expertise 1': data.expertise1 || "NA",
          'Expertise 2': data.expertise2 || "NA",
          'LinkedIn': data.linkedIn || "NA",
          'GitHub': data.github || "NA",
          'Portfolio': data.portfolio || "NA",
          'Others': data.other || "NA"
        }));

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Set column widths for better readability
      const columnWidths = [
        { wch: 20 }, // Timestamp
        { wch: 20 }, // Name
        { wch: 20 }, // Registration Number
        { wch: 15 }, // Phone Number
        { wch: 15 }, // Whatsapp Number
        { wch: 30 }, // Email
        { wch: 30 }, // Srm Mail ID
        { wch: 8 },  // Year
        { wch: 15 }, // Branch
        { wch: 20 }, // Preference 1
        { wch: 20 }, // Preference 2
        { wch: 20 }, // Expertise 1
        { wch: 20 }, // Expertise 2
        { wch: 25 }, // LinkedIn
        { wch: 25 }, // GitHub
        { wch: 25 }, // Portfolio
        { wch: 20 }  // Others
      ];
      worksheet['!cols'] = columnWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Envision CFA Data');

      // Write and download the file
      XLSX.writeFile(workbook, 'Envision_CFA_Data.xlsx');
    } catch (error) {
      console.error('Error downloading Envision CFA data:', error);
      alert('Error downloading Envision CFA data. Please try again.');
    }
  };
  return (
    <>
      <div className="col-lg-7">
        <button 
          type="button" 
          className="btn btn-success float-right m-3"
          onClick={downloadCFAData}
          disabled={cfas.length === 0}
        >
          Export CFA Data (Excel)
        </button>

        <button 
          type="button" 
          className="btn btn-success float-right m-3"
          onClick={downloadEnvisionData}
          disabled={envisionCfas.length === 0 || role !== "aaruush-envision-heads"}
        >
          Export Envision CFA Data (Excel)
        </button>
      </div>
    </>
  );
};

export default CFA;
